<template>
  <b-modal
    ref="jobModal"
    id="jobDescriptionModal"
    size="lg"
    modal-class="job-description-modal"
  >
    <!-- Header with Pagination -->
    <template #modal-header>
      <div class="w-100 d-flex justify-content-between align-items-center">
        <!-- <h5>{{ currentJob.title }}</h5> -->
        <span style="color: #006C6B"
          >{{ currentIndex + 1 }}/{{ totalJobs }} 件表示</span
        >
        <span
          @click="hide"
          style="cursor: pointer; margin-top: 5px; color: #006C6B; font-size: 24px;"
        >
          &times;
        </span>
      </div>
    </template>

    <!-- Job Description Content -->
     <div class="jd-content">
        <Loader v-if="loading" />
        <div class="job-content" v-else>
          <div class="job-header pad-1" style="border-bottom: 1px solid #787878;">
            <h3 class="mb-2" style="font-weight: 600">{{ currentJob.company }}</h3>
            <h5>{{ currentJob.job_title }}</h5>
          </div>  
          <div v-html="currentJob.job_description" class="description pad-1"></div>
        </div>
     </div>

    <template #modal-footer>
      <div class="d-flex w-100" style="justify-content: space-around" v-if="!loading">
        <div class="scout-button-section">
          <b-button
            @click="handleScout"
            :class="buttonClass"
            :disabled="isScouted"
          >
            {{buttonText}}
          </b-button>
          <p :class="isScouted ? 'scouted-hint' : 'scout-hint'">
            {{ scoutHintText }}
          </p>
        </div>
        <div class="scout-button-section">
          <b-button
            @click="handleNext"
            class="next-button"
            style="height: 44px;"
          >
            次を見る
          </b-button>
          <!-- <p class="scout-hint">企業からスカウトが届きやすくなります</p> -->
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Loader from "@/components/Loader.vue";
export default {
  name: "JobDescriptionModal",
  components: {
    Loader,
  },
  props: {
    currentJob: {
      type: Object,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    totalJobs: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    isJobScouted: {
      type: Boolean,
      required: false,
    },
    hasReachedScoutLimit: {
      type: Boolean, 
      required: false,
    }
  },
  computed: {
    isScouted() {
      return this.isJobScouted || this.hasReachedScoutLimit || false;
    },
    scoutHintText(){
      if(this.isJobScouted) {
        return '';
      } else if(this.hasReachedScoutLimit) {
        return 'スカウト希望は3件まで可能です';
      }
      return '企業からスカウトが届きやすくなります'
    },
    buttonText() {
      if(this.isJobScouted) {
        return 'スカウト希望済'
      } else {
        return 'スカウトを希望する'
      }
    },
    buttonClass() {
      if(this.isJobScouted) {
        return 'scouted-button'
      } else if(this.hasReachedScoutLimit) {
        return 'scout-limit-button'
      } else {
        return 'scout-button'
      }
    }
  },
  methods: {
    show() {
      this.$refs.jobModal.show();
    },
    hide() {
      this.$emit('close');
      this.$refs.jobModal.hide();
    },
    handleScout() {
      if (this.isScouted) {
        return;
      }
      this.$emit("scout");
    },
    handleNext() {
      this.$emit("next");
    },
  },
};
</script>
<style scoped>
.scout-hint {
  text-align: center;
  color: #ff0000;
  font-size: 9px;
}
.scouted-hint {
  text-emphasis: center;
  color: #787878;
  font-size: 9px;
  margin-right: 10px;
}
.placeholder-height {
  height: 10px;
}
.pad-1 {
  padding: 1rem;
}
.description {
  height: 60vh; overflow-y: auto;
}
>>> .job-description-modal .modal-body {
  padding: 0px !important;
}
>>> .job-description-modal .modal-footer {
  background: #f2f5f7 !important;
  padding-bottom: 0px;
}
</style>
